export function appendSearchParams(
    path: string,
    currentSearch: string,
): string {
    if (!currentSearch) return path;

    const separator = path.includes('?') ? '&' : '?';
    return `${path}${separator}${currentSearch}`;
}
